import './CustomAnalyticsDashboard.scss';
import React, { useMemo } from 'react';
import { ReactComponent as AddGraphImage } from 'assets/images/experience-analytics.svg';
import { FlightButton } from '@flybits/design-system';
import { useHistory, useParams } from 'react-router-dom';
import GraphTile from './GraphTile/GraphTile';
import { VISUALIZER_OPTIONS } from '../CreateOrEditChart/constants';
import useExperienceGraphsData from 'pages/AnalyticsV2/CustomAnalytics/hooks/useExperienceGraphsData';
import { TAnalyticsRouteParams } from 'pages/AnalyticsV2/types';
import LoadingIcon from 'components/Shared/LoadingIcon/LoadingIcon';

// CLASSES
const CLASS_MAIN = 'custom-analytics-dashboard';
const CLASS_FULL_PAGE_SPINNER = 'analytics-container__full-page-spinner';
const CLASSES = {
  BODY: `${CLASS_MAIN}__body`,
  GRID: `${CLASS_MAIN}__grid`,
  TILE: `${CLASS_MAIN}__tile`,
  RECENT_TILE: `${CLASS_MAIN}__tile--recent`,
  TILE_ADD_CHART: `${CLASS_MAIN}__tile__add-chart`,
  CHART: `${CLASS_MAIN}__chart`,
  ADD_CHART: `${CLASS_MAIN}__add-chart`,
};
const getValidGraphType = (graphType: string) => {
  switch (graphType.toLowerCase()) {
    case VISUALIZER_OPTIONS.BAR:
      return VISUALIZER_OPTIONS.BAR;
    case VISUALIZER_OPTIONS.LINE:
      return VISUALIZER_OPTIONS.LINE;
    case VISUALIZER_OPTIONS.TABLE:
      return VISUALIZER_OPTIONS.TABLE;
    default:
      return VISUALIZER_OPTIONS.UNSUPORTED;
  }
};
const SYSTEM_GENERATED_GRAPH_IDS = [
  '10000000-0000-0000-0000-000000000000',
  '20000000-0000-0000-0000-000000000000',
  '30000000-0000-0000-0000-000000000000',
];

function CustomAnalyticsDashboard() {
  const history = useHistory();
  const { pid } = useParams<TAnalyticsRouteParams>();
  const recentGraphId = useMemo(() => new URLSearchParams(window.location.search).get('recentGraphId') || '', []);

  const { graphs, isGraphsLoading, graphsData, isGraphsDataLoading } = useExperienceGraphsData();
  return isGraphsLoading ? (
    <main className={CLASS_FULL_PAGE_SPINNER}>
      <LoadingIcon />
    </main>
  ) : (
    <main className={CLASSES.BODY}>
      <div className={CLASSES.GRID}>
        {graphs
          // Filter out system generated graphs
          .filter((graph) => !SYSTEM_GENERATED_GRAPH_IDS.includes(graph.id))
          // Most recently updated order
          .sort((graphA, graphB) => graphB.updatedAt - graphA.updatedAt)
          .map((graph, index) => (
            <div key={graph.id} className={`${CLASSES.TILE} ${graph.id === recentGraphId ? CLASSES.RECENT_TILE : ''}`}>
              <GraphTile
                id={graph.id}
                title={graph.name}
                description={graph.description}
                graphType={getValidGraphType(graph.chartConfig.type)}
                graphData={graphsData[index]}
                isGraphLoading={isGraphsDataLoading}
              />
            </div>
          ))}
        <div className={CLASSES.TILE_ADD_CHART}>
          <div className={CLASSES.ADD_CHART}>
            <AddGraphImage />
            <h6>Experience Analytics</h6>
            <p>Track metrics across different experiences to see how they’re performing.</p>
            <FlightButton
              label="Add Chart"
              iconLeft="add"
              size="small"
              onClick={() => history.push(`/project/${pid}/analytics/v2/moduleconfig`)}
            />
          </div>
        </div>
      </div>
    </main>
  );
}

export default CustomAnalyticsDashboard;
